import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { mapEveryBigintIntoNumber } from 'utils/map-every-bigint-into-number';
import { EcomResponseSchema } from '../../pb/responses/v1/ecom_response_pb';
import httpApi, { goBackendApi } from '../hooks/api/httpApi';
import { Ecom } from '../models/Ecom';
import { HomeDeliveryShippingRate } from '../models/ppoints/HomeDeliveryShippingRate';

const getEcom = async (): Promise<Ecom> => {
    const response = await new ProtobufClient(goBackendApi()).getRequest(EcomResponseSchema, '/api/v1/ecom');
    return mapEveryBigintIntoNumber(response) as Ecom;
};

const uninstall = async (ecomId: number) => {
    let res = await httpApi.post<{ success: boolean; message: string }>(`/api/ecom/${ecomId}/uninstall`);
    return res.getData();
};

const getHomeDeliveryShippingRates = async (ecomId: number | null) => {
    if (!ecomId) return Promise.reject();
    let res = await httpApi.get<HomeDeliveryShippingRate[]>(`/api/ecom/${ecomId}/home-delivery-shipping-rates`);
    let data = res.getData();
    return data;
};

const getPaymentMethods = async (ecomId: number | null): Promise<string[]> => {
    if (!ecomId) return Promise.reject();
    let res = await httpApi.get<PaymentMethods>(`/api/ecom/${ecomId}/payment-methods`);
    let data = res.getData();
    return data.payment_methods;
};

const getManualPaymentMethods = async (ecomId: number | null): Promise<string[]> => {
    if (!ecomId) return Promise.reject();
    let res = await httpApi.get<PaymentMethods>(`/api/ecom/${ecomId}/manual-payment-methods`);
    let data = res.getData();
    return data.payment_methods;
};

export default {
    getEcom,
    uninstall,
    getHomeDeliveryShippingRates,
    getPaymentMethods,
    getManualPaymentMethods,
};

export interface PaymentMethods {
    payment_methods: string[];
}
